import * as React from 'react'

interface Props {
  loading: boolean | undefined
  selectedFileId: string | undefined
  selectedPage: number | undefined
  payslipsToDistribute: number | undefined
  payslipsToDiscard: number | undefined
  payslipsNotAssigned: number | undefined
  payslipsToMerge: number | undefined
  setLoading: (value: boolean) => void
  setPayslipsToDistribute: (value: number) => void
  setPayslipsToDiscard: (value: number) => void
  setPayslipsNotAssigned: (value: number) => void
  setPayslipsToMerge: (value: number) => void
}
export const ManualDocumentAssignerContext = React.createContext<Props>({
  loading: false,
  setLoading: () => {},
  selectedFileId: '0',
  selectedPage: 0,
  payslipsToDistribute: undefined,
  setPayslipsToDistribute: () => {},
  payslipsToDiscard: undefined,
  setPayslipsToDiscard: () => {},
  payslipsNotAssigned: undefined,
  setPayslipsNotAssigned: () => {},
  payslipsToMerge: undefined,
  setPayslipsToMerge: () => {},
})

export const useManualDocumentAssignerContext = () =>
  React.useContext(ManualDocumentAssignerContext)
